export const activeServiceQueryParameterName = 'service';
export const searchQueryParameterName = 'q';
